import { z } from 'zod'

import type { Language } from '@nxt-insurance/constants'

import { publicHealthSchema } from '@flows/configs/de/publicHealth/types'
import type { generateGetFlowValueFunctions } from '@flows/insurance/utils'

export interface PublicHealthStepParams {
  getCurrentLanguage: () => Language
  helperFunctions: ReturnType<typeof generateGetFlowValueFunctions>
  environment: string
  platform: 'web' | 'native'
}

export const previousInsurerSchema = z.object({
  products: z.object({
    mga_public_health_de: z.object({
      configuration_parameters: publicHealthSchema.pick({
        previous_insurer: true,
      }),
    }),
  }),
})

export const employmentSchema = z.object({
  products: z.object({
    mga_public_health_de: z.object({
      configuration_parameters: publicHealthSchema.pick({
        employment_status: true,
      }),
    }),
  }),
})

export const incomeSchema = z.object({
  products: z.object({
    mga_public_health_de: z.object({
      configuration_parameters: publicHealthSchema.pick({
        income: true,
      }),
    }),
  }),
})

export const includeKidsSchema = z.object({
  products: z.object({
    mga_public_health_de: z.object({
      configuration_parameters: publicHealthSchema.pick({
        include_kids: true,
      }),
    }),
  }),
})

export const successSchema = z.object({})
